import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "@/lib/firebase";
import {
  LayoutDashboard,
  Users,
  UserCheck,
  CreditCard,
  FileEdit,
  LogOut,
  ChevronLeft,
  ChevronRight,
  FileText,
} from "lucide-react";

const links = [
  { to: "/dashboard/admin/overview", label: "Overview", icon: <LayoutDashboard className="h-5 w-5" /> },
  { to: "/dashboard/admin/users", label: "Users", icon: <Users className="h-5 w-5" /> },
  { to: "/dashboard/admin/instructors", label: "Instructors", icon: <UserCheck className="h-5 w-5" /> },
  { to: "/dashboard/admin/payments", label: "Payments", icon: <CreditCard className="h-5 w-5" /> },
  { to: "/dashboard/admin/content", label: "Content", icon: <FileEdit className="h-5 w-5" /> },
  { to: "/dashboard/admin/or", label: "OR", icon: <FileText className="h-5 w-5" /> },
];

const AdminSidebar: React.FC = () => {
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(true);
  
  const handleLogout = async () => {
    await signOut(auth);
    navigate("/");
  };

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <aside className={`h-full bg-background border-r p-4 flex flex-col transition-all duration-300 relative ${isCollapsed ? 'w-20' : 'w-64'}`}>
      {/* Toggle button positioned in the middle of the sidebar */}
      <button
        onClick={toggleSidebar}
        className="absolute -right-3 top-1/2 transform -translate-y-1/2 bg-background border rounded-full p-1 hover:bg-muted transition-colors z-10 shadow-sm"
      >
        {isCollapsed ? <ChevronRight className="h-4 w-4" /> : <ChevronLeft className="h-4 w-4" />}
      </button>
      
      <div className="mb-8">
        {!isCollapsed && (
          <div>
            <h2 className="text-2xl font-bold">MSS Driving School</h2>
            <p className="text-muted-foreground text-sm">Admin Panel</p>
          </div>
        )}
      </div>
      
      <nav className="space-y-1 flex-1">
        {links.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) =>
              `w-full flex items-center px-3 py-2 rounded-md transition-colors ${isActive ? "bg-muted text-primary" : "hover:bg-muted/50"} ${isCollapsed ? 'justify-center' : ''}`
            }
            title={isCollapsed ? link.label : undefined}
          >
            {link.icon}
            {!isCollapsed && <span className="ml-3">{link.label}</span>}
          </NavLink>
        ))}
      </nav>
      
      <button
        onClick={handleLogout}
        className={`w-full flex items-center px-3 py-2 rounded-md mt-4 text-left hover:bg-muted/50 transition-colors ${isCollapsed ? 'justify-center' : ''}`}
        title={isCollapsed ? "Logout" : undefined}
      >
        <LogOut className="h-5 w-5" />
        {!isCollapsed && <span className="ml-3">Logout</span>}
      </button>
    </aside>
  );
};

export default AdminSidebar;
